module.exports = "/images/vendor/flag-icon-css/flags/1x1/pt.svg?04fa443dfc5d7647ec4adab4da283554";